import React, {Component} from 'react'
import MaskedInput from 'react-text-mask' /* https://github.com/text-mask/text-mask/tree/master/react#readme */
import axios from 'axios'

import TelaResposta from '../Response'
import RecaptchaV3Component from '../../components/recaptchaV3'
import 'url-search-params-polyfill'

class IncidentScreen extends Component {

    constructor(props) {
        super(props);
        this.state = {
            urlbackend: '',
            servidor: props.servidor,
            tela: '',
            tipo_form: '',
            cpf: '',
            nome: '',
            telefone: '',
            email: '',
            sobre: 'X',
            assunto: 'X',
            relato: '',
            arquivo: '',
            contador: 0,
            protocolo: '',
            srvr: '',
            cidade: '',
            estado: '',
            perfil: 'X',
            matricula: '',
            regional: '',
            envolvidos: '',
            obrigatorioDocumento: false,
            arrayEnvolvidos: [],
            nomeTemp: '',
            sobrenomeTemp: '',
            perfilOutro: '',
            loading: false,
        }
    }

    componentDidMount() {
        // pega o tipo de denuncia na url
        let urlParams = new URLSearchParams(window.location.search)
        this.setState({ tipo_form: urlParams.get('t') })

        // cria hash único
        //this.setProtocolo() - o servidor que retornará o protocolo agora

        // verifica url para direcionar o backend
        let urlsite = window.location.href;
        if (urlsite.indexOf('local') > -1 ){
            this.setState({ urlbackend: 'http://wp.crefisa.local:8080', srvr: 'local' })
        }else if (urlsite.indexOf('denunciad.') > -1){
            this.setState({ urlbackend: 'https://www2-d.crefisa.com.br', srvr: 'dsv' })
        }else if (urlsite.indexOf('denunciah.') > -1) {
            this.setState({ urlbackend: 'https://www2-h.crefisa.com.br', srvr: 'hmg' })
        }else{
            this.setState({ urlbackend: 'https://www.crefisa.com.br', srvr: 'prd' })
        }
    }

    setProtocolo() {
        let randomstring = Math.random().toString(36).slice(-10).toUpperCase();
        this.setState({ protocolo: randomstring })
    }

    _onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    countTxt = (e) => {
        let max = e.target.getAttribute('data-max')

        if (e.target.value.length <= max) {
            this.setState({ contador: e.target.value.length })
            this._onChange(e)
        }
    }
    
    validaText = (e) => {
        const words = ["FOTO", "VIDEO", "AUDIO", "ÁUDIO", "VÍDEO"];

        if(words.some(el => this.state.relato.toUpperCase().includes(el))){
            this.setState({obrigatorioDocumento: true});
        }else{
            this.setState({obrigatorioDocumento: false});
        }
    }

    /**
     * Marca o campo com erro
     */
    setFieldError = (campo, msg) => {
        alert(msg);
        document.getElementsByName(campo)[0].style.borderColor = "red"
        document.getElementsByName(campo)[0].focus()
    }

    setFieldComponentError = (campo, classe, msg) => {
        alert(msg);
        document.getElementsByClassName(classe)[0].style.borderColor = "red"
        document.getElementById(campo).focus()
    }

    /**
     * Marca o campo como ok
     */
    setFieldOk = (campo) => {
        document.getElementsByName(campo)[0].style.borderColor = null;
    }

    setFieldComponentOk = (classe) => {
        document.getElementsByClassName(classe)[0].style.borderColor = null;
    }

     validarCPF = (cpf) => {	
        cpf = cpf.replace(/[^\d]+/g,'');	
        if(cpf === '') return false;	
        // Elimina CPFs invalidos conhecidos	
        if (cpf.length !== 11 || 
            cpf === "00000000000" || 
            cpf === "11111111111" || 
            cpf === "22222222222" || 
            cpf === "33333333333" || 
            cpf === "44444444444" || 
            cpf === "55555555555" || 
            cpf === "66666666666" || 
            cpf === "77777777777" || 
            cpf === "88888888888" || 
            cpf === "99999999999")
                return false;		
        // Valida 1o digito	
        let add = 0;	
        let rev;
        for (let i=0; i < 9; i ++)		
            add += parseInt(cpf.charAt(i)) * (10 - i);	
            rev = 11 - (add % 11);	
            if (rev === 10 || rev === 11)		
                rev = 0;	
            if (rev !== parseInt(cpf.charAt(9)))		
                return false;		
        // Valida 2o digito	
        add = 0;	
        for (let i = 0; i < 10; i ++)		
            add += parseInt(cpf.charAt(i)) * (11 - i);	
        rev = 11 - (add % 11);	
        if (rev === 10 || rev === 11)	
            rev = 0;	
        if (rev !== parseInt(cpf.charAt(10)))
            return false;		
        return true;   
    }
    /**
     * Valida o formulário
     */

    validaform = (e) => {
        this.setState({ loading: true })
        e.preventDefault()
        if (this.state.loading) {
            return
        }
        
        
        if (this.state.tipo_form === '1'){
            // nome
            if (this.state.nome === undefined || this.state.nome === '') {
                this.setFieldError('nome', 'Preencha o nome corretamente.')
                this.setState({ loading: false })
                return false
            }else if (this.state.nome.length <= 3) {
                this.setFieldError('nome', 'O nome deve possuir mais de 3 letras.')
                this.setState({ loading: false })
                return false
            }else{
                this.setFieldOk('nome')
            }

            if (this.state.cpf === undefined || this.state.cpf === '' ||  !this.validarCPF(this.state.cpf)) {
                this.setFieldError('cpf', 'Preencha o CPF corretamente.')
                this.setState({ loading: false })
                return false
            }else{
                this.setFieldOk('cpf')
            }

             // email
             let re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
             if (this.state.email === undefined || this.state.email === '') {
                 this.setFieldError('email', 'Preencha o email corretamente.')
                 this.setState({ loading: false })
                 return false
             }else if (this.state.email.length <= 3) {
                 this.setFieldError('email', 'O email deve possuir mais de 3 letras.')
                 this.setState({ loading: false })
                 return false
             }else if (!re.test(this.state.email.toLowerCase())){
                 this.setFieldError('email', 'Email inválido.')
                 this.setState({ loading: false })
                 return false
             }else{
                 this.setFieldOk('email')
             }

            // telefone
            if (this.state.telefone === undefined || this.state.telefone === '') {
                this.setFieldError('telefone', 'Preencha o telefone corretamente.')
                this.setState({ loading: false })
                return false
            }else if (this.state.telefone.length <= 13) {
                this.setFieldError('telefone', 'Telefone inválido.')
                this.setState({ loading: false })
                return false
            }else{
                this.setFieldOk('telefone')
            }   
        }
            if (this.state.tipo_form === '1'){
                // perfil
                if (this.state.perfil === undefined || this.state.perfil === 'X') {
                    this.setFieldComponentError('perfil', 'iptPerfil', 'Selecione o campo Você é.')
                    this.setState({ loading: false })
                    return false
                }else{
                    this.setFieldComponentOk('iptPerfil')
                }

                if(this.state.perfil === 'Outros'){
                    // perfil
                    if (this.state.perfilOutro === undefined || this.state.perfilOutro === '') {
                        this.setFieldError('perfilOutro', 'Preencha o campo "Especificação do perfil" corretamente.')
                        this.setState({ loading: false })
                        return false
                    }else{
                        this.setFieldOk('perfilOutro')
                    }
                }

                if(this.state.perfil === 'Colaborador'){               
                        //matricula
                        if (this.state.matricula === undefined || this.state.matricula === '') {
                            this.setFieldError('matricula', 'Preencha o campo "Matricula" corretamente.')
                            this.setState({ loading: false })
                            return false
                        }else{
                            this.setFieldOk('matricula')
                        }
                    
                    //matricula
                    if (this.state.regional === undefined || this.state.regional === '') {
                        this.setFieldError('regional', 'Preencha o campo "Regional" corretamente.')
                        this.setState({ loading: false })
                        return false
                    }else{
                        this.setFieldOk('regional')
                    }

                }
            }

            // cidade
            if (this.state.cidade === undefined || this.state.cidade === '') {
                this.setFieldError('cidade', 'Preencha o campo "Cidade" corretamente.')
                this.setState({ loading: false })
                return false
            }else{
                this.setFieldOk('cidade')
            }

            // estado
            if (this.state.estado === undefined || this.state.estado === 'X' || this.state.estado === '') {
                this.setFieldComponentError('estado', 'iptEstado', 'Preencha o campo "Estado" corretamente.')
                this.setState({ loading: false })
                return false
            }else{
                this.setFieldComponentOk('iptEstado')
            }

             // sobre
            if (this.state.sobre === undefined || this.state.sobre === 'X') {
                this.setFieldComponentError('sobre', 'iptSobre', 'Selecione o campo Sobre quem.')
                this.setState({ loading: false })
                return false
            }else{
                this.setFieldComponentOk('iptSobre')
            }

            // assunto
            if (this.state.assunto === undefined || this.state.assunto === 'X') {
                this.setFieldComponentError('assunto', 'iptAssunto', 'Selecione o Assunto.')
                this.setState({ loading: false })
                return false
            }else{
                this.setFieldComponentOk('iptAssunto')
            }

            // relato
            if (this.state.relato === undefined || this.state.relato === '') {
                this.setFieldError('relato', 'Informe a Denúncia.')
                this.setState({ loading: false })
                return false
            }else{
                this.setFieldOk('relato')
            }     

            let tempThis = this;
            
            if(this.state.arrayEnvolvidos.length > 0){
                let envolvidosTemp;

                this.state.arrayEnvolvidos.map((valor) => {
                    envolvidosTemp = envolvidosTemp ? envolvidosTemp + ', '+ valor.value : valor.value;
                });
                envolvidosTemp = envolvidosTemp.toString();
                this.setState({
                    envolvidos: envolvidosTemp
                }, () => {
                    tempThis.enviaFormulario()
                })
                
            }else if(this.state.nomeTemp !== '' || (this.state.tipo_form !== '1' && this.state.sobre !== 'Colaboradores') || this.state.tipo_form === '1') {              
                const nomeCompleto = this.state.nomeTemp + ' ' + this.state.sobrenomeTemp;
                this.setState({
                    envolvidos: nomeCompleto
                }, () => {
                    tempThis.enviaFormulario()
                })
            }else{
                this.setFieldError('nomeTemp', 'Preencha o nome dos envolvidos corretamente.')
            }


    }

     addNewName = () => {
         // nome
         if (this.state.nomeTemp === undefined || this.state.nomeTemp === '') {
            this.setFieldError('nomeTemp', 'Preencha o nome dos envolvidos corretamente.')
            return false
        }else if (this.state.nomeTemp.length <= 3) {
            this.setFieldError('nomeTemp', 'O nome dos envolvidos deve possuir mais de 3 letras.')
            return false
        }else{
            this.setFieldOk('nomeTemp')
        }

        const nome = this.state.nomeTemp  + ' ' + this.state.sobrenomeTemp 
        const itensCopy = Array.from(this.state.arrayEnvolvidos);
        itensCopy.push({id: this.state.arrayEnvolvidos.length, value: nome});

        this.setState({
            arrayEnvolvidos: itensCopy,
            nomeTemp: '',
            sobrenomeTemp: ''
        })


    }
    
    deleteName = (index) => {
        const itensCopy = Array.from(this.state.arrayEnvolvidos);
        itensCopy.splice(index, 1);

        this.setState({
            arrayEnvolvidos: itensCopy
        })
    }

    enviaFormulario = async () => {
        var formData  = new FormData()

        let urlsite = window.location.href;
        let srvr = '';

        if (urlsite.indexOf('local') > -1 ){
            srvr = 'local'
        }else if (urlsite.indexOf('denunciad.') > -1){
            srvr = 'dsv'
        }else if (urlsite.indexOf('denunciah.') > -1) {
            srvr = 'hmg'
        }else{
            srvr = 'prd'
        }

        let token = document.getElementById('token').value

        let dados = JSON.stringify({
            'cpf': this.state.cpf,
            'nome': this.state.nome,
            'telefone': this.state.telefone,
            'email': this.state.email.toLowerCase(),
            
            'sobre': this.state.sobre,
            'assunto': this.state.assunto,
            'relato': this.state.relato,
            'servidor': this.state.servidor,
            'tipo_denuncia': (this.state.tipo_form === '1') ? 'identificada' : 'anônima',
            'protocolo': this.state.protocolo,
            'arquivo': this.state.arquivo,
            'srvr': srvr,
            'token': token,

            'cidade': this.state.cidade,
            'estado': this.state.estado,
            'perfil': this.state.perfil === 'Outros' ? this.state.perfilOutro : this.state.perfil ,
            'matricula': this.state.matricula,
            'regional': this.state.regional,
            'envolvidos': this.state.envolvidos,
            'file': this.state.file
        })
        formData.append('dados', dados)

        var imagefile = document.querySelector('#arquivo');
        
        if(this.state.obrigatorioDocumento){    
            if(!imagefile.files[0]){
                this.setFieldError('arquivo', 'Anexe um arquivo.')
                return
            }
        }

        if(imagefile.files[0]){
            if(imagefile.files[0].size > 5242880){
                this.setFieldError('arquivo', 'Tamanho do arquivo maior que o permitido.')
                return
            }

            if(!(imagefile.files[0].type === 'application/pdf' ||
                imagefile.files[0].type.includes('audio/') ||
                imagefile.files[0].type.includes('video/') ||
                imagefile.files[0].type.includes('image/')) 
            ){
                this.setFieldError('arquivo', 'Formato do arquivo não permitido')
                return
            }
        }

        formData.append("image", imagefile.files[0]);
        let self = this

        await axios.post(
            this.state.urlbackend + '/canal_denuncia/enviarApi', 
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
            )
        .then(function (response){
            if (response.data.status === 'ok' && response.data.protocolo !== undefined){
                alert('Denúncia enviada!')
                self.setState({ tela: 'resposta' , protocolo: response.data.protocolo})
            }else{
                if (response.data.protocolo === undefined){
                    alert('Ocorreu um erro: Não foi possível recuperar número de protocolo\nPor favor tente novamente!')
                }else{
                    alert('Ocorreu um erro: ' + response.data.message)
                }
            }
        })

        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        })
        this.setState({ loading: false })
    }

    
    render() {
        const { servidor, tipo_form } = this.state

        if (this.state.tela === 'resposta') {

            return (  
                <TelaResposta protocolo={this.state.protocolo}/>
            )

        }else if(this.state.error){

            return (
                <div className="text-danger">
                    {this.state.error.message}
                    <br />
                    {this.state.error.internalMessage}
                </div>
                )
        }else{
            let btn_denuncia = null

            if (tipo_form === '1') {
                btn_denuncia = 'bt_realizar_denuncia_identificada'
            }else{
                btn_denuncia = 'bt_realizar_denuncia_anonima'
            }

            var telmask = function(rawValue) {
                if (rawValue.length < 15 ){
                    return ['(', /[1-9]/, /\d/, ')', ' ', /[1-9]/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
                }else{
                    return ['(', /[1-9]/, /\d/, ')', ' ', /[1-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
                }
            }

            return(
                <div>
                    <br />

                    <form method="post" id="incidente" name="incidente" autoComplete="off" onSubmit={(e)=>{e.preventDefault()}}>
                        <input type="hidden" name="origem" id="origem" value={servidor} />

                        <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                              <div className="col-md-12 col-sm-12 col-xs-12 quadro" style={{marginTop: '35px'}}>
                              {tipo_form === '1'  && <div className="quadro-text" >SEUS DADOS</div> }
                                {tipo_form === '1'  && (
                                 <div>
                                     <div className="form-group form-group-sm form-inline col-12 justify-content-between">
                                        <div className="form-group form-group-sm form-inline col-12">
                                            <label htmlFor="nome" className="control-label">Nome:<span className="obrigatorio">*</span></label>
                                            <input 
                                                onChange={this._onChange} 
                                                type="text" 
                                                className="form-control input-sm iptNome" 
                                                id="nome" 
                                                name="nome" 
                                                placeholder="NOME" 
                                                autoComplete="nome" 
                                                value={this.state.nome} 
                                                required />
                                        </div>

                                        <div className="form-group form-group-sm form-inline col-12 espaco-campo">
                                            <label htmlFor="cpf" className="control-label">CPF:<span className="obrigatorio">*</span></label>
                                            <input 
                                                onChange={this._onChange} 
                                                type="text" 
                                                className="form-control input-sm iptCpf" 
                                                id="cpf" 
                                                name="cpf" 
                                                placeholder="CPF" 
                                                autoComplete="cpf"
                                                maxLength="11"
                                                value={this.state.cpf} />
                                        </div>
                                    </div>
                                    

                                <div className="form-group form-group-sm form-inline col-12">
                                        <div className="form-group form-group-sm form-inline col-12">
                                            <label htmlFor="email" className="control-label">E-mail:{tipo_form === '1'  && (<span className="obrigatorio">*</span>)}</label>
                                            <input 
                                                onChange={this._onChange} 
                                                type="email" 
                                                className="form-control input-sm iptEmail" 
                                                id="email" 
                                                name="email" 
                                                placeholder="E-MAIL" 
                                                autoComplete="email" 
                                                value={this.state.email.toLowerCase()} 
                                                required />
                                        </div>

                                        <div className="form-group form-group-sm form-inline col-12 espaco-campo">
                                            <label htmlFor="telefone" className="control-label">Telefone:<span className="obrigatorio">*</span></label>
                                            <MaskedInput 
                                                guide={false} 
                                                /*mask={['(', /[1-9]/, /\d/, ')', ' ', /[1-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]} */
                                                mask={telmask}
                                                onChange={this._onChange} 
                                                type="text" 
                                                className="form-control input-sm iptTelefone" 
                                                id="telefone" 
                                                name="telefone" 
                                                placeholder="(99) 9999-9999" 
                                                autoComplete="telefone"
                                                keepCharPositions={true}
                                                value={this.state.telefone} />
                                        </div>
                                    </div>
                                </div>
                                )}

                                <div className="form-group form-group-sm form-inline col-12">
                                    <div className="form-group form-group-sm form-inline col-12">
                                        <label htmlFor="cidade" className="control-label">Cidade:<span className="obrigatorio">*</span></label>
                                        <input 
                                            onChange={this._onChange} 
                                            type="text" 
                                            className="form-control input-sm iptNome" 
                                            id="cidade" 
                                            name="cidade" 
                                            placeholder="cidade" 
                                            autoComplete="cidade"
                                            maxLength="40"
                                            value={this.state.cidade} />
                                    </div>

                                    <div className="form-group form-group-sm form-inline col-12 espaco-campo">
                                        <label htmlFor="estado" className="control-label">Estado:<span className="obrigatorio">*</span></label>
                                        <select 
                                            onChange={this._onChange} 
                                            className="form-control Select-control input-sm iptEstado" 
                                            id="estado" 
                                            name="estado" 
                                            value={this.state.estado} 
                                            required>                                          
                                                <option value="X"  data-valor="">Selecione</option>
                                                <option data-valor="AC" value="AC">AC</option>
                                                <option data-valor="AL" value="AL">AL</option>
                                                <option data-valor="AM" value="AM">AM</option>
                                                <option data-valor="AP" value="AP">AP</option>
                                                <option data-valor="BA" value="BA">BA</option>
                                                <option data-valor="CE" value="CE">CE</option>
                                                <option data-valor="DF" value="DF">DF</option>
                                                <option data-valor="ES" value="ES">ES</option>
                                                <option data-valor="GO" value="GO">GO</option>
                                                <option data-valor="MA" value="MA">MA</option>
                                                <option data-valor="MG" value="MG">MG</option>
                                                <option data-valor="MS" value="MS">MS</option>
                                                <option data-valor="MT" value="MT">MT</option>
                                                <option data-valor="PA" value="PA">PA</option>
                                                <option data-valor="PB" value="PB">PB</option>
                                                <option data-valor="PE" value="PE">PE</option>
                                                <option data-valor="PI" value="PI">PI</option>
                                                <option data-valor="PR" value="PR">PR</option>
                                                <option data-valor="RJ" value="RJ">RJ</option>
                                                <option data-valor="RN" value="RN">RN</option>
                                                <option data-valor="RO" value="RO">RO</option>
                                                <option data-valor="RR" value="RR">RR</option>
                                                <option data-valor="RS" value="RS">RS</option>
                                                <option data-valor="SC" value="SC">SC</option>
                                                <option data-valor="SE" value="SE">SE</option>
                                                <option data-valor="SP" value="SP">SP</option>
                                                <option data-valor="TO" value="TO">TO</option>
                                        </select>
                                    </div>
                                </div>



                                {tipo_form === '1' &&
                                <>
                                    <div className="form-group form-group-sm form-inline col-12">
                                        <div className="form-group form-group-sm form-inline col-12">
                                            <label htmlFor="perfil" className="control-label">Você é:<span className="obrigatorio">*</span></label>
                                            <select 
                                                onChange={this._onChange} 
                                                className="form-control Select-control input-sm iptPerfil" 
                                                id="perfil" 
                                                name="perfil" 
                                                value={this.state.perfil} 
                                                required>                                          
                                                    <option value="X"  data-valor="">Selecione</option>
                                                    <option value="Colaborador" data-valor="Colaborador">Colaborador</option>
                                                    <option value="Cliente" data-valor="Cliente">Cliente</option>
                                                    <option value="Fornecedor" data-valor="Fornecedor">Fornecedor</option>
                                                    <option value="Prestador de Serviços" data-valor="Prestador de Serviços">Prestador de Serviços</option>
                                                    <option value="Outros" data-valor="Outros">Outros</option>
                                            </select>
                                        </div>

                                        { this.state.perfil === 'Outros' && (
                                            <div className="form-group form-group-sm form-inline col-12 espaco-campo">
                                                <label htmlFor="perfilOutro" className="control-label">Especifique:<span className="obrigatorio">*</span></label>
                                                <input 
                                                    onChange={this._onChange} 
                                                    type="text" 
                                                    className="form-control input-sm" 
                                                    id="perfilOutro" 
                                                    name="perfilOutro" 
                                                    placeholder="Especifique" 
                                                    autoComplete="perfilOutro"
                                                    maxLength="50"
                                                    value={this.state.perfilOutro} />
                                            </div>
                                        )}

                                        {this.state.perfil === 'Colaborador' && (
                                            <div className="form-group form-group-sm form-inline col-12 espaco-campo">
                                                <label htmlFor="matricula" className="control-label">Matricula:<span className="obrigatorio">*</span></label>
                                                <input 
                                                    onChange={this._onChange} 
                                                    type="text" 
                                                    className="form-control input-sm" 
                                                    id="matricula" 
                                                    name="matricula" 
                                                    placeholder="matricula" 
                                                    autoComplete="matricula"
                                                    maxLength="12"
                                                    value={this.state.matricula} />
                                            </div>
                                        )}

                                        {this.state.perfil === 'Colaborador' && (
                                            <div className="form-group form-group-sm form-inline col-12 espaco-campo">
                                                <label htmlFor="regional" className="control-label">Regional:<span className="obrigatorio">*</span></label>
                                                <input 
                                                    onChange={this._onChange} 
                                                    type="text" 
                                                    className="form-control input-sm" 
                                                    id="regional" 
                                                    name="regional" 
                                                    placeholder="regional" 
                                                    autoComplete="regional"
                                                    maxLength="40"
                                                    value={this.state.regional} />
                                            </div>
                                        )}
                                    </div>
                                </>
                                }
                            </div>

                            <div className="col-md-12 col-sm-12 col-xs-12 quadro">
                              <div className="quadro-text quadro-text-envolvidos">IDENTIFICAÇÃO DOS ENVOLVIDOS</div>
                                <div className="form-group form-group-sm form-inline col-12">
                                    <div className="form-group form-group-sm form-inline col-12 ">
                                        <label htmlFor="sobre" className="control-label">Sobre quem:<span className="obrigatorio">*</span></label>
                                        <select 
                                            onChange={this._onChange} 
                                            className="form-control Select-control input-sm iptSobre" 
                                            id="sobre" 
                                            name="sobre" 
                                            value={this.state.sobre} 
                                            required>                                          
                                                <option value="X"  data-valor="">Selecione</option>
                                                <option value="Área responsável" data-valor="Área responsável">Área responsável</option>
                                                <option value="Clientes" data-valor="Clientes">Clientes</option>
                                                <option value="Colaboradores" data-valor="Colaboradores">Colaboradores</option>
                                                <option value="Departamento" data-valor="Departamento">Departamento</option>
                                                <option value="Fornecedores" data-valor="Fornecedores">Fornecedores</option>
                                                <option value="Ponto de Atendimento" data-valor="Ponto de Atendimento">Ponto de Atendimento</option>
                                                <option value="Prestador de serviço" data-valor="Prestador de serviço">Prestador de serviço</option>              
                                                <option value="outros" data-valor="outros">Outros</option>
                                        </select>
                                    </div>                                   
                                </div>

                                <div className="form-group form-group-sm form-inline col-12">

                                    <div className="form-group form-group-sm form-inline col-12">
                                        <label htmlFor="nomeTemp" className="control-label">Nome:
                                            {this.state.tipo_form !== '1' && this.state.sobre === 'Colaboradores' &&
                                                <span className="obrigatorio">*</span>
                                            }
                                        </label>
                                        <input 
                                            onChange={this._onChange} 
                                            type="text" 
                                            className="form-control input-sm iptNome" 
                                            id="nomeTemp" 
                                            name="nomeTemp" 
                                            placeholder="Nome do envolvido" 
                                            autoComplete="nomeTemp"
                                            maxLength="300"
                                            value={this.state.nomeTemp} />
                                </div>

                                    <div className="form-group form-group-sm form-inline col-12  espaco-campo">
                                        <label htmlFor="sobrenomeTemp" className="control-label">Sobrenome:</label>
                                        <input 
                                            onChange={this._onChange} 
                                            type="text" 
                                            className="form-control input-sm iptNome" 
                                            id="sobrenomeTemp" 
                                            name="sobrenomeTemp" 
                                            placeholder="Sobrenome do envolvido" 
                                            autoComplete="sobrenomeTemp"
                                            maxLength="300"
                                            value={this.state.sobrenomeTemp} />
                                    </div>
                                    

                                    <div onClick={() => this.addNewName()} className="form-group form-group-sm form-inline col-12 image-add" title="Adicionar nome.">
                                        <img  src="/img/add2.png"  width={"100%"} />
                                    </div>
                                </div>


                                {this.state.arrayEnvolvidos.length > 0 &&
                                    <div className="nome-envolvidos">
                                       NOMES ADICIONADOS
                                    </div>
                                    
                                }


                                {this.state.arrayEnvolvidos.map(({id, value}, index) => (
                                    <div className="form-group form-group-sm form-inline col-12" key={id}>
                                        <div className="form-group form-group-sm form-inline col-12"  >
                                            {value}
                                        </div>

                                        <div onClick={() => this.deleteName(index)} className="form-group form-group-sm form-inline col-12 image-remove" title="Remover nome.">
                                            <img  src="/img/remove2.png"  width={"100%"} />
                                        </div>
                                    </div>
                                ))}

                            </div>

                                <div className="col-md-12 col-sm-12 col-xs-12 quadro">
                              <div className="quadro-text">DENÚNCIA</div>
                              <div className="form-group form-group-sm form-inline col-12">
                                <div className="form-group form-group-sm form-inline col-12">
                                    <label htmlFor="assunto" className="control-label">Assunto:<span className="obrigatorio">*</span></label>
                                        <select 
                                            onChange={this._onChange} 
                                            className="form-control Select-control input-sm iptAssunto" 
                                            id="assunto" 
                                            name="assunto" 
                                            value={this.state.assunto} 
                                            required>                                          
                                                <option value="X"  data-valor="">Selecione</option>
                                                <option value="Assédio" data-valor="Assédio">Assédio</option>
                                                <option value="Conduta" data-valor="Conduta">Conduta</option>
                                                <option value="Corrupção" data-valor="Corrupção">Corrupção</option>
                                                <option value="Conflito de interesses" data-valor="Conflito de interesses">Conflito de interesses</option>
                                                <option value="Discriminação" data-valor="Discriminação">Discriminação</option>
                                                <option value="Fraude" data-valor="Fraude">Fraude</option>
                                                <option value="Roubo/Furto" data-valor="Roubo/Furto">Roubo/Furto</option>
                                                <option value="Segurança" data-valor="Segurança">Segurança</option>
                                                <option value="Outros" data-valor="Outros">Outros</option>
                                        </select>
                                    </div>  
                                </div>

                                <div className="form-group form-group-sm col-12">
                                    <label htmlFor="relato" className="control-label">Relato:<span className="obrigatorio">*</span></label>
                                    <textarea
                                        onPaste={(e) => {
                                            e.preventDefault();
                                            return false;
                                          }}
                                          onCopy={(e) => {
                                            e.preventDefault();
                                            return false;
                                          }}
                                          onCut={(e) => {
                                            e.preventDefault();
                                            return false;
                                          }}
                                        onChange={this.countTxt} 
                                        onBlur={this.validaText}
                                        className="form-control input-sm txtRelato" 
                                        rows="5" 
                                        maxLength="1500" 
                                        data-max="1500"  
                                        id="relato" 
                                        name="relato" 
                                        placeholder="SUA DENÚNCIA" 
                                        value={this.state.relato} 
                                        required />
                                    <span id="helpBlock" className="help-block">Para o campo acima, é permitido a digitação máxima de 1500 caracteres, há <span className="contador">{this.state.contador}</span> de 1500!</span>
                                </div>
                                
                                <div className="form-group form-group-sm form-inline col-12">
                                    <label htmlFor="arquivo" className="control-label">Evidências (tamanho máximo 5MB): 
                                        {this.state.obrigatorioDocumento &&
                                            <span className="obrigatorio">*</span>
                                        }
                                    </label>

                                    <input 
                                        type="file" 
                                        className="form-control-file input-file" 
                                        id="arquivo" 
                                        name="arquivo"
                                    />
                                </div>
                                 <p>Tipos e formatos de arquivos permitidos: jpg, gif, png, bmp, tif, dwg, zip, plt, pdf, txt, csv.</p>
                                 <span className="obrigatorio">* Todas as opções que possuírem o asterisco são de preenchimento obrigatório</span>
                                </div>
                  
                  
                                
                                <RecaptchaV3Component />

                                <div className="form-group form-group-sm col-12">
                                    <p align="center">
                                        <a href="/" onClick={this.validaform} disabled={this.state.loading} title="Realizar denúncia" shape="rect" className={btn_denuncia}></a>
                                    </p>
                                </div>
                                            
                            </div>
                        </div>

                    </form>
                </div>
            )
        }
    }
}

export default IncidentScreen